<article class="usecase-card flex flex-col min-h-0" [attr.id]="card.id">
  <div class="usecase-card__image-wrap shrink-0 w-full overflow-hidden">
    <img [src]="card.imageSrc" [alt]="card.title" class="usecase-card__image" loading="lazy" />
  </div>

  <div class="usecase-card__content flex flex-col flex-1 min-w-0">
    <div class="usecase-card__body flex flex-col gap-3 flex-1 min-w-0">
      <h3 class="usecase-card__title m-0 leading-snug">{{ card.title }}</h3>
      <p class="usecase-card__description m-0 text-base leading-relaxed">{{ card.shortDescription }}</p>
    </div>

    <footer class="usecase-card__footer flex items-center justify-between gap-3 shrink-0">
      <span class="usecase-card__tag inline-flex items-center gap-1.5 max-w-[60%] min-w-0">
        <img [src]="card.tagIcon" alt="" class="usecase-card__tag-icon shrink-0" width="16" height="16" />
        <span class="usecase-card__tag-label truncate">{{ card.tagLabel }}</span>
      </span>
      <button type="button" class="usecase-card__cta inline-flex items-center gap-1 shrink-0" (click)="onViewClick($event)">
        <span>View usecase</span>
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M5 12H19M19 12L12 5M19 12L12 19"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </footer>
  </div>
</article>
